import OrgLink from "../../components/Layout/OrganizersLink";

export default function SLEEPLESS({ children }) {
  return (
    <>
      <p>
        SLEEP is a two-part experience comprising SLEEP: DIVING IN and SLEEP: LESS, exploring
        elements of ideal sleep hygiene rituals to overcome insomnia and the stories of individuals
        with different relationships to sleep.
      </p>
      <p>
        SLEEP: LESS explores eight sleep stories of individuals with unique relationships to sleep
        and their associated brain activities. How do the daily lives of a post-natal mother, a
        doctor on 30-hour night call duty and a night-shift security guard intersect in their
        sleepless routines? In this VR experience, narratives unfold through an immersive
        exploration of disrupted sleep cycles and other ways of inhabiting our restless city. With
        curiosity, we nurture a sense of empathy for those among us who often do not have a choice
        in their circadian rhythms, finding loneliness, solitude, or hidden networks.
      </p>
      <p>
        These stories of everyday people, from hawkers to night-shift taxi drivers, beg us to
        question:
      </p>
      <p>What if there are many ways to nurture circadian cycles?</p>
      <p>
        What if, beyond the ebb and flow of moonrise, we could also tune into the tides and rhythms
        of our inner body clock, our creative soul and the calling of a job at once, privilege and
        curse?
      </p>
      {children}
      <div className="credits">
        SLEEP is presented in partnership with Naumi Hotel Singapore, co-organised by Forest & Whale
        in collaboration with students from the BA (Hons) Design for Social Futures programme at the
        Lasalle College of the Arts, University of the Arts Singapore, and <OrgLink name={"Hans"} />
        .
      </div>
    </>
  );
}
